import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import {assertAndContinue} from 'Asserts';
import {isBrowser} from 'lib/Browser';

export interface ClickOutWrapperProps {
  children: React.ReactNode;
  shouldCloseOnInsideClick?: boolean;
  onClickOut: (e: MouseEvent) => void;
}

export default class ClickOutWrapper extends React.Component<ClickOutWrapperProps> {
  static defaultProps = {
    shouldCloseOnInsideClick: false,
  };

  override componentDidMount(): void {
    if (isBrowser) {
      window.addEventListener('click', this.handleBodyClick, true);
    }
  }

  override componentWillUnmount(): void {
    if (isBrowser) {
      window.removeEventListener('click', this.handleBodyClick, true);
    }
  }

  private handleBodyClick = (e: MouseEvent): void => {
    // TODO(BNCH-153827) findDOMNode is going away in React 19; this is scheduled for deletion
    // oxlint-disable-next-line react/no-find-dom-node
    const node = ReactDOM.findDOMNode(this);
    if (!assertAndContinue(node != null, 'Expected component to be mounted')) {
      return;
    }
    const $node = $(node!);
    const inDOMNode = $(e.target!).closest($node).length > 0;
    if (this.props.shouldCloseOnInsideClick || !inDOMNode) {
      this.props.onClickOut(e);
    }
  };

  override render(): React.ReactNode {
    return this.props.children;
  }
}
